// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__1IY73","icon":"SortAdornment_icon__PBuh7","up":"SortAdornment_up__3hld5","down":"SortAdornment_down__1OWXK","active":"SortAdornment_active__3L0tD"};